import { SOCIAL_FORMS, STREET_ADDRESS_REGEX } from "./constants";

export const isSiretValid = (siretNumber) => {
  return /^\d{14}$/.test(siretNumber);
};

export const isSirenValid = (term) => {
  return /^[\d ]+$/.test(term); // we consider that a term containing only numbers and spaces is meant to be a SIREN number
};

export const isEligibleForShareholders = (socialForm) => {
  return isSingleShareholderCompany(socialForm) || isEligibleForMultipleShareholders(socialForm);
};

export const isEligibleForMultipleShareholders = (socialForm) => {
  return !isIndividualEnterprise(socialForm) && !isSingleShareholderCompany(socialForm);
};

export const isSingleShareholderCompany = (socialForm) =>
  [SOCIAL_FORMS.SASU, SOCIAL_FORMS.SELASU, SOCIAL_FORMS.EURL].includes(socialForm);

export const isIndividualEnterprise = (socialForm) => [SOCIAL_FORMS.EI, SOCIAL_FORMS.EIRL].includes(socialForm);

export const isMicro = (socialForm) => socialForm === SOCIAL_FORMS.MICRO;

export const employerSalaryCost = (amount) => {
  return (amount * 1.4).toFixed(2);
};

export const isStreetAddressValid = (address) => {
  return address.match(STREET_ADDRESS_REGEX);
};

export const calcPercentageHeld = (totalNumberOfShares, numberOfSharesHeld) =>
  ((Math.max(numberOfSharesHeld, 0) / totalNumberOfShares) * 100).toFixed(2);

export const handleOtpFlow = (url, { onOtpRequired, onOtpNotRequired }) => {
  fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.otp_required) {
        onOtpRequired();
      } else {
        onOtpNotRequired();
      }
    });
};
